import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import EarlyAccessForm from "@/components/EarlyAccessForm";
import { Container, Section } from "@/components/Primitives";

const VALUES = ["Discipline", "Clarity", "Honesty", "The line holds"];

export default function About() {
    return (
        <div className="bg-parchment text-ink">
            <Seo
                title="About"
                description="The Aegis Line started as a personal problem: one trader, one account, and a system that was fine while the decisions around it weren't. It became the protection discretionary trading can't provide for itself."
            />

            {/* Light hero */}
            <section className="border-b border-ink/10">
                <Container className="py-20 sm:py-28">
                    <span className="font-mono text-[0.72rem] uppercase tracking-[0.22em] text-rule-lo">
                        The story behind The Aegis Line
                    </span>
                    <h1 className="mt-5 max-w-4xl text-4xl font-extrabold leading-[1.08] text-ink sm:text-5xl">
                        Built by a trader who needed the line to hold.
                    </h1>
                </Container>
            </section>

            <Section>
                <Container className="grid items-start gap-12 lg:grid-cols-[1.1fr_0.9fr]">
                    <Reveal>
                        <div className="space-y-6 text-base leading-relaxed text-ink/75 sm:text-lg">
                            <p>
                                The Aegis Line started as a personal problem. One
                                trader, one account, and a persistent pattern:
                                the system was fine but the decisions around it
                                weren't. Moving stops. Adjusting parameters to
                                fit recent sessions. Convincing himself that a
                                change was an improvement when it was really a
                                response to the last trade. The analysis was
                                sound. The{" "}
                                <span className="font-semibold text-ink">
                                    discipline
                                </span>{" "}
                                wasn't. Nothing was protecting the line.
                            </p>
                            <p>
                                What grew out of that is The Aegis Line: a
                                serious attempt to build the protection that
                                discretionary trading can't provide for itself.
                                Deterministic analysis that never varies. A
                                reasoning model that makes the call from clean
                                facts. A methodology that holds its standard in
                                writing, publicly, so there's something to be
                                held to. And an honest account of the gap between
                                paper and live — because the aegis only works if
                                it holds when it's inconvenient.
                            </p>
                        </div>

                        <div className="mt-10">
                            <span className="font-mono text-[0.72rem] uppercase tracking-[0.22em] text-rule-lo">
                                What we hold to
                            </span>
                            <div className="mt-4 flex flex-wrap gap-3">
                                {VALUES.map((v) => (
                                    <span
                                        key={v}
                                        className="rounded border border-ink/15 bg-white/50 px-4 py-2 font-mono text-sm text-ink"
                                    >
                                        {v}
                                    </span>
                                ))}
                            </div>
                        </div>
                    </Reveal>

                    <Reveal delay={0.12}>
                        <img
                            src="/images/about_abstract.png"
                            alt="An abstract dark composition with a single unmoveable gold horizontal line"
                            className="w-full rounded-lg border border-ink/10"
                            loading="lazy"
                        />
                        <div className="mt-8 rounded-lg border border-haze bg-ink p-6">
                            <p className="text-sm text-text-hi">
                                Want to follow the build honestly?
                            </p>
                            <p className="mt-1 text-sm text-text-lo">
                                Join the early-access list.
                            </p>
                            <div className="mt-5">
                                <EarlyAccessForm compact />
                            </div>
                        </div>
                    </Reveal>
                </Container>
            </Section>
        </div>
    );
}
